import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCo2Icon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M41.033 26.86c-2.75 0-4.986 2.252-4.986 5.022 0 2.77 2.236 5.023 4.986 5.023 2.751 0 4.987-2.252 4.987-5.023-.02-2.77-2.256-5.023-4.987-5.023Zm0 8.45c-1.88 0-3.403-1.534-3.403-3.428 0-1.893 1.524-3.428 3.403-3.428 1.88 0 3.404 1.535 3.404 3.428-.02 1.894-1.543 3.429-3.404 3.429Z",
				fill: "url(#b)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.415 31.882c1.049-1.056 2.593-2.59 2.75-2.79a5.085 5.085 0 0 0 1.109-3.15c0-2.77-2.236-5.022-4.987-5.022-2.75.02-4.986 2.272-4.986 5.043 0 1.136.396 2.252 1.108 3.149.158.2 1.702 1.734 2.75 2.79-1.048 1.057-2.592 2.591-2.75 2.79a5.085 5.085 0 0 0-1.108 3.15c0 2.77 2.236 5.023 4.986 5.023 2.75 0 4.987-2.252 4.987-5.023a5.085 5.085 0 0 0-1.108-3.15c-.158-.218-1.702-1.753-2.75-2.81Zm-3.78-3.787a3.378 3.378 0 0 1-.751-2.132c0-1.894 1.523-3.429 3.403-3.429 1.88 0 3.404 1.535 3.404 3.429 0 .797-.257 1.534-.752 2.152-.158.2-1.544 1.575-2.652 2.671-1.108-1.136-2.493-2.511-2.651-2.69Zm2.652 13.155c-1.88 0-3.403-1.534-3.403-3.428 0-.797.257-1.535.752-2.133.158-.179 1.543-1.574 2.651-2.67 1.108 1.116 2.494 2.491 2.652 2.67.495.618.752 1.356.752 2.153a3.412 3.412 0 0 1-3.404 3.408Z",
				fill: "url(#c)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.114 37.822c1.05-1.056 2.593-2.591 2.751-2.79a5.085 5.085 0 0 0 1.108-3.15 5.085 5.085 0 0 0-1.108-3.149c-.158-.2-1.702-1.734-2.75-2.79 1.048-1.057 2.592-2.591 2.75-2.79a5.086 5.086 0 0 0 1.108-3.15c0-2.75-2.236-5.003-4.986-5.003C20.236 15 18 17.252 18 20.023c0 1.136.396 2.252 1.108 3.15.158.198 1.702 1.733 2.75 2.79-1.048 1.056-2.592 2.59-2.75 2.79A4.989 4.989 0 0 0 18 31.883c0 1.136.396 2.252 1.108 3.149.158.199 1.702 1.734 2.75 2.79-1.048 1.056-2.592 2.591-2.75 2.79A5.003 5.003 0 0 0 18 43.762c0 2.77 2.236 5.023 4.987 5.023 2.75 0 4.986-2.253 4.986-5.023a5.086 5.086 0 0 0-1.108-3.15c-.158-.219-1.702-1.754-2.75-2.79Zm-3.779-15.647a3.433 3.433 0 0 1-.752-2.152c0-1.894 1.524-3.428 3.404-3.428s3.403 1.534 3.403 3.428c0 .797-.257 1.535-.752 2.152-.158.2-1.543 1.575-2.651 2.671a54559.89 54559.89 0 0 1-2.652-2.67Zm0 11.86a3.392 3.392 0 0 1-.752-2.153 3.3 3.3 0 0 1 .752-2.132c.158-.18 1.543-1.575 2.652-2.671 1.108 1.116 2.493 2.491 2.651 2.67.495.619.752 1.356.752 2.153 0 .798-.257 1.535-.752 2.133-.158.18-1.543 1.575-2.651 2.67-1.109-1.115-2.494-2.49-2.652-2.67Zm2.652 13.135c-1.88 0-3.404-1.535-3.404-3.428a3.3 3.3 0 0 1 .752-2.133c.158-.18 1.543-1.575 2.652-2.67 1.108 1.115 2.493 2.49 2.651 2.67.495.618.752 1.355.752 2.153a3.411 3.411 0 0 1-3.403 3.408Z",
				fill: "url(#d)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "b",
			x1: 41.025,
			y1: 26.868,
			x2: 41.025,
			y2: 36.906,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#36EB92" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#1E6761"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "c",
			x1: 32.285,
			y1: 20.934,
			x2: 32.285,
			y2: 42.84,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#36EB92" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#1E6761"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "d",
			x1: 22.983,
			y1: 15,
			x2: 22.983,
			y2: 48.774,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#36EB92" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#1E6761"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				transform: "translate(18 15)",
				d: "M0 0h28v33.765H0z"
			})
		})
	] })]
});
export default SvgCo2Icon;
